import { useFeatureLayout } from 'hooks/use-feature-layout';
import useMediaQuery from 'hooks/use-media-query';
import { useUIContext } from 'state/ui';

export const useCartLoadingImage = () => {
  const matches = useMediaQuery('mobile');
  const { buildImageUrl } = useUIContext();
  const { featureLayout } = useFeatureLayout();

  const cartInitialLoader = featureLayout?.loadingGraphics?.cartInitialLoader;
  const graphic = matches ? cartInitialLoader?.mobileGraphic : cartInitialLoader?.desktopGraphic;
  const imageId = graphic?.asset?._id;
  return {
    src: imageId ? buildImageUrl(imageId) : '',
    alt: cartInitialLoader?.title?.locale || undefined,
    text: cartInitialLoader?.text?.locale,
  };
};
